import newMessage from '../../../assets/sounds/newMessage.mp3'
import newConversation from '../../../assets/sounds/newConversation.mp3'
import closeConversation from '../../../assets/sounds/closeConversation.mp3'
import overdueConversation from '../../../assets/sounds/overdueConversation.mp3'

import storage from '../../../utils/storage'

export default class AudioComponent {
  static instance = null
  _volume = parseInt(storage.get('volume') ?? '100')
  _notificationNewMessageSound = new Audio(newMessage)
  _notificationNewConversationSound = new Audio(newConversation)
  _notificationCloseConversationSound = new Audio(closeConversation)
  _notificationOverdueConversationSound = new Audio(overdueConversation)

  static get inst() {
    if (AudioComponent.instance == null) {
      AudioComponent.instance = new AudioComponent()
    }
    return this.instance
  }

  static get volume() {
    return AudioComponent.inst._volume
  }

  static setVolume(volume) {
    storage.set('volume', volume)
    AudioComponent.inst._volume = volume
    AudioComponent.inst._notificationNewMessageSound.volume = volume / 100
    AudioComponent.inst._notificationNewConversationSound.volume = volume / 100
    AudioComponent.inst._notificationCloseConversationSound.volume = volume / 100
    AudioComponent.inst._notificationOverdueConversationSound.volume = volume / 100

  }

  static play(sound) {
    switch (sound) {
      case 'newMessage':
        AudioComponent.inst._notificationNewMessageSound.play()
        break
      case 'newConversation':
        AudioComponent.inst._notificationNewConversationSound.play()
        break
      case 'closeConversation':
        AudioComponent.inst._notificationCloseConversationSound.play()
        break
      case 'overdueConversation':
        AudioComponent.inst._notificationOverdueConversationSound.play()
        break
      default:
        AudioComponent.inst._notificationNewMessageSound.play()
        break
    }
  }
}
